import ChainList from '../components/ChainList';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {Link} from 'react-router-dom';
import WorkflowCascadeEditor,{blankCascade,validCascade} from '../components/WorkflowCascadeEditor';
import ReactFlow, {
  Background, Controls, MarkerType,
  useNodesState, useEdgesState,
} from 'reactflow';
import 'reactflow/dist/style.css';
import { chainsAPI, automationsAPI } from '../services/api';
import { Plus, GitBranch, ArrowLeft, Sparkles } from 'lucide-react';
import SegmentFilterPanel from '../components/SegmentFilterPanel';
import EmailEditor from '../components/EmailEditor';
import toast from 'react-hot-toast';
import './Chains.css';
import './ChainBuilder.css';
import {StartNode,StepNode,AddNode} from '../components/ChainCanvasNodes';
import ChainDrawer from '../components/ChainDrawer';
import ChainAssistant from '../components/ChainAssistant';


const COLORS = { start: '#1f2937', wait: '#6b7280', filter: '#8b5cf6', sms: '#22c55e', email: '#3b82f6',cascade:'#a78bfa' };
const LABELS = { wait: 'Ожидание', filter: 'Фильтр', sms: 'SMS', email: 'Email',cascade:'Боты → Email → SMS' };
const ICONS = { wait: '⏱', filter: '🔀', sms: '💬', email: '✉️',cascade:'⇢' };

const BRANCH_COLORS = ['#8b5cf6','#22c55e','#3b82f6','#f59e0b','#ef4444','#ec4899','#14b8a6','#f97316'];



const nodeTypes = { start: StartNode, step: StepNode, addStep: AddNode };


function EmailEditorInline({ subject, onSubjectChange, htmlContent, onHtmlChange, designJson, onDesignChange }) {
  return (
    <EmailEditor
      value={htmlContent}
      onChange={onHtmlChange}
      subject={subject}
      onSubjectChange={onSubjectChange}
      channel="email"
      onDesignChange={onDesignChange}
      initialDesign={designJson}
    />
  );
}



function StartConfigModal({ form, triggers, onSave, onClose }) {
  const [f, setF] = useState({
    ...form,
    trigger_config: form.trigger_config || {},
  });
  const [rfmSegments, setRfmSegments] = useState([]);
  const [savedSegments, setSavedSegments] = useState([]);
  const [tiersList, setTiersList] = useState([]);
  const [products, setProducts] = useState([]);
  const [productSearch, setProductSearch] = useState('');
  const [places, setPlaces] = useState([]);

  const grouped = {};
  (triggers || []).forEach(t => { if (!grouped[t.group]) grouped[t.group] = []; grouped[t.group].push(t); });

  useEffect(() => {
    import('../services/api').then(m => {
      m.analyticsAPI.rfm().then(r => setRfmSegments(r.data?.segments?.map(s => s.name) || [])).catch(() => {});
      m.savedSegmentsAPI.list().then(r => setSavedSegments(r.data || [])).catch(() => {});
      m.loyaltyAPI.tiers().then(r => setTiersList(r.data || [])).catch(() => {});
      m.placesAPI.list().then(r => setPlaces(r.data || [])).catch(() => {});
    });
  }, []);

  useEffect(() => {
    if (['purchase', 'first_purchase', 'repeat_purchase'].includes(f.trigger)) {
      const t = setTimeout(() => {
        import('../services/api').then(m => {
          m.catalogAPI.products(0, 50, null, productSearch || null, false).then(r => setProducts(r.data?.items || [])).catch(() => {});
        });
      }, 300);
      return () => clearTimeout(t);
    }
  }, [productSearch, f.trigger]);

  const tc = f.trigger_config || {};
  const setTC = (key, val) => setF({ ...f, trigger_config: { ...tc, [key]: val } });

  const trigger = f.trigger;

  return (
    <ChainDrawer title="Событие входа" wide={false} onClose={onClose}>

        <div className="form-group"><label className="form-label">Название</label>
          <input className="form-input" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} placeholder="Приветственная цепочка" /></div>

        <div className="form-group"><label className="form-label">Триггер</label>
          <select className="form-input" value={f.trigger} onChange={e => setF({ ...f, trigger: e.target.value, trigger_config: {} })}>
            {Object.entries(grouped).map(([group, items]) => (
              <optgroup key={group} label={group}>
                {items.map(t => <option key={t.type} value={t.type}>{t.label}</option>)}
              </optgroup>
            ))}
          </select></div>


        {(trigger === 'segment_enter' || trigger === 'segment_leave') && (
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>
              {trigger === 'segment_enter' ? 'Условие: клиент попал в...' : 'Условие: клиент вышел из...'}
            </div>
            <div className="form-group"><label className="form-label">Тип сегмента</label>
              <select className="form-input" value={tc.segment_type || 'rfm'} onChange={e => setTC('segment_type', e.target.value)}>
                <option value="rfm">RFM-сегмент</option>
                <option value="saved">Сохранённый сегмент</option>
              </select></div>
            {tc.segment_type === 'saved' ? (
              <div className="form-group"><label className="form-label">Сегмент</label>
                <select className="form-input" value={tc.saved_segment_id || ''} onChange={e => setTC('saved_segment_id', e.target.value)}>
                  <option value="">Любой сохранённый сегмент</option>
                  {savedSegments.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select></div>
            ) : (
              <div className="form-group"><label className="form-label">RFM-сегмент</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {rfmSegments.map(s => (
                    <button key={s} type="button"
                      className={`btn btn-sm ${(tc.rfm_segments || []).includes(s) ? 'btn-primary' : 'btn-ghost'}`}
                      style={{ fontSize: 11, padding: '2px 8px' }}
                      onClick={() => {
                        const arr = tc.rfm_segments || [];
                        setTC('rfm_segments', arr.includes(s) ? arr.filter(x => x !== s) : [...arr, s]);
                      }}>{s}</button>
                  ))}
                </div>
                <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 4 }}>Пусто = любой сегмент</div>
              </div>
            )}
          </div>
        )}


        {trigger === 'tier_upgrade' && (
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Условие: перешёл на уровень</div>
            <div className="form-group">
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {tiersList.map(t => (
                  <button key={t.name} type="button"
                    className={`btn btn-sm ${(tc.target_tiers || []).includes(t.name) ? 'btn-primary' : 'btn-ghost'}`}
                    style={{ fontSize: 11, padding: '2px 8px' }}
                    onClick={() => {
                      const arr = tc.target_tiers || [];
                      setTC('target_tiers', arr.includes(t.name) ? arr.filter(x => x !== t.name) : [...arr, t.name]);
                    }}>{t.display_name}</button>
                ))}
              </div>
              <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 4 }}>Пусто = любой уровень</div>
            </div>
          </div>
        )}


        {['purchase', 'first_purchase', 'repeat_purchase'].includes(trigger) && (
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Условия покупки (необязательно)</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="form-group"><label className="form-label">Сумма от</label>
                <input className="form-input" type="number" min="0" value={tc.min_order_total || ''} onChange={e => setTC('min_order_total', e.target.value)} placeholder="Любая" /></div>
              <div className="form-group"><label className="form-label">Сумма до</label>
                <input className="form-input" type="number" min="0" value={tc.max_order_total || ''} onChange={e => setTC('max_order_total', e.target.value)} placeholder="Любая" /></div>
            </div>
            <div className="form-group"><label className="form-label">Сумма покупок до след. уровня ≤</label>
              <input className="form-input" type="number" min="0" value={tc.max_to_next_tier || ''} onChange={e => setTC('max_to_next_tier', e.target.value)} placeholder="Не учитывать" /></div>
            <div className="form-group"><label className="form-label">Место покупки</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {places.map(p => (
                  <button key={p.id} type="button"
                    className={`btn btn-sm ${(tc.place_ids || []).includes(p.id) ? 'btn-primary' : 'btn-ghost'}`}
                    style={{ fontSize: 11, padding: '2px 8px' }}
                    onClick={() => {
                      const arr = tc.place_ids || [];
                      setTC('place_ids', arr.includes(p.id) ? arr.filter(x => x !== p.id) : [...arr, p.id]);
                    }}>{p.name}</button>
                ))}
              </div></div>
            <div className="form-group"><label className="form-label">Товар в заказе</label>
              <input className="form-input" style={{ marginBottom: 6, fontSize: 12 }} placeholder="Поиск товара..."
                value={productSearch} onChange={e => setProductSearch(e.target.value)} />
              {tc.product_ids?.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 6 }}>
                  {tc.product_ids.map(pid => {
                    const pr = products.find(p => String(p.id) === String(pid));
                    return <span key={pid} className="badge badge-info" style={{ cursor: 'pointer' }}
                      onClick={() => setTC('product_ids', tc.product_ids.filter(x => x !== pid))}>{pr?.name || pid} ✕</span>;
                  })}
                </div>
              )}
              {products.length > 0 && (
                <div style={{ maxHeight: 120, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 6 }}>
                  {products.filter(p => !(tc.product_ids || []).includes(String(p.id))).slice(0, 10).map(p => (
                    <div key={p.id} style={{ padding: '4px 8px', fontSize: 12, cursor: 'pointer', borderBottom: '1px solid var(--border)' }}
                      onClick={() => setTC('product_ids', [...(tc.product_ids || []), String(p.id)])}>{p.name}</div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}


        {trigger === 'bonus_activated' && (
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Условие (необязательно)</div>
            <div className="form-group"><label className="form-label">Мин. кол-во активированных бонусов</label>
              <input className="form-input" type="number" min="1" value={tc.min_bonus_amount || ''} onChange={e => setTC('min_bonus_amount', e.target.value)} placeholder="Любое количество" /></div>
          </div>
        )}


        {trigger === 'bonus_expiring' && (
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Условие (необязательно)</div>
            <div className="form-group"><label className="form-label">Мин. кол-во сгорающих бонусов</label>
              <input className="form-input" type="number" min="1" value={tc.min_expiring_amount || ''} onChange={e => setTC('min_expiring_amount', e.target.value)} placeholder="Любое количество" /></div>
          </div>
        )}


        {trigger === 'birthday' && (
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12, marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>Условия (необязательно)</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div className="form-group"><label className="form-label">Пол</label>
                <select className="form-input" value={tc.gender || ''} onChange={e => setTC('gender', e.target.value)}>
                  <option value="">Любой</option>
                  <option value="male">Мужской</option>
                  <option value="female">Женский</option>
                </select></div>
              <div className="form-group"><label className="form-label">Сколько лет исполнилось</label>
                <input className="form-input" type="number" min="1" value={tc.turning_age || ''} onChange={e => setTC('turning_age', e.target.value)} placeholder="Любой возраст" /></div>
            </div>
          </div>
        )}


        <div className="form-group"><label className="form-label">Количество запусков</label>
          <select className="form-input" value={f.run_mode} onChange={e => setF({ ...f, run_mode: e.target.value })}>
            <option value="once">Один раз на клиента</option><option value="every">Каждый раз</option></select></div>
        {f.run_mode === 'every' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            <div className="form-group"><label className="form-label">Не чаще (раз)</label>
              <input className="form-input" type="number" min="1" value={f.max_runs_per_period || ''} onChange={e => setF({ ...f, max_runs_per_period: e.target.value })} /></div>
            <div className="form-group"><label className="form-label">За (дней)</label>
              <input className="form-input" type="number" min="1" value={f.period_days || ''} onChange={e => setF({ ...f, period_days: e.target.value })} /></div>
            <div className="form-group"><label className="form-label">Пауза (ч)</label>
              <input className="form-input" type="number" min="0" value={f.pause_hours || ''} onChange={e => setF({ ...f, pause_hours: e.target.value })} /></div>
          </div>
        )}

        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" onClick={() => { onSave(f); onClose(); }}>Применить к схеме</button>
        </div>
    </ChainDrawer>
  );
}

function FilterConfigModal({ step, onSave, onClose }) {
  const [branches, setBranches] = useState(step.config?.branches || [{ id: 'b_1', label: 'Ветка 1', segment_filter: { segments: [], loyalty_tiers: [], place_ids: [] } }]);
  const [activeBranch, setActiveBranch] = useState(0);

  const addBranch = () => {
    setBranches([...branches, { id: `b_${Date.now()}`, label: `Ветка ${branches.length + 1}`, segment_filter: { segments: [], loyalty_tiers: [], place_ids: [] } }]);
  };
  const removeBranch = (i) => {
    if (branches.length <= 1) { toast.error('Нужна хотя бы одна ветка'); return; }
    const next = branches.filter((_, idx) => idx !== i);
    setBranches(next);
    if (activeBranch >= next.length) setActiveBranch(next.length - 1);
  };
  const updateBranch = (i, key, val) => {
    const next = [...branches]; next[i] = { ...next[i], [key]: val }; setBranches(next);
  };

  return (
    <ChainDrawer title="Условия и ветки" wide={true} onClose={onClose}>
        <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 16 }}>
          Клиент проходит по всем веткам, условия которых совпадают. Ветки выполняются параллельно.
        </p>


        <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          {branches.map((b, i) => (
            <div key={b.id} style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <button onClick={() => setActiveBranch(i)}
                style={{
                  padding: '6px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
                  background: activeBranch === i ? BRANCH_COLORS[i % BRANCH_COLORS.length] : '#f3f4f6',
                  color: activeBranch === i ? '#fff' : '#374151',
                }}>
                {b.label || `Ветка ${i + 1}`}
              </button>
              {branches.length > 1 && (
                <button onClick={() => removeBranch(i)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d1d5db', padding: 0, fontSize: 14 }}
                  onMouseOver={e => e.target.style.color = '#ef4444'} onMouseOut={e => e.target.style.color = '#d1d5db'}>✕</button>
              )}
            </div>
          ))}
          <button onClick={addBranch} style={{ padding: '6px 12px', borderRadius: 6, border: '1px dashed #d1d5db', background: 'transparent', cursor: 'pointer', fontSize: 12, color: '#9ca3af' }}>
            + Ветка
          </button>
        </div>


        {branches[activeBranch] && (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 }}>
            <div className="form-group">
              <label className="form-label">Название ветки</label>
              <input className="form-input" value={branches[activeBranch].label || ''} onChange={e => updateBranch(activeBranch, 'label', e.target.value)} placeholder="VIP клиенты" />
            </div>
            <div className="form-group">
              <label className="form-label">Режим</label>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => updateBranch(activeBranch, 'exclude', false)}
                  style={{
                    padding: '6px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
                    background: !branches[activeBranch].exclude ? '#22c55e' : '#f3f4f6',
                    color: !branches[activeBranch].exclude ? '#fff' : '#374151',
                  }}>
                  ✓ Включить — клиент попадает в сегмент
                </button>
                <button onClick={() => updateBranch(activeBranch, 'exclude', true)}
                  style={{
                    padding: '6px 14px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
                    background: branches[activeBranch].exclude ? '#ef4444' : '#f3f4f6',
                    color: branches[activeBranch].exclude ? '#fff' : '#374151',
                  }}>
                  ✗ Исключить — клиент НЕ попадает в сегмент
                </button>
              </div>
            </div>
            <SegmentFilterPanel
              filters={branches[activeBranch].segment_filter || { segments: [], loyalty_tiers: [], place_ids: [] }}
              onChange={sf => updateBranch(activeBranch, 'segment_filter', sf)}
            />
          </div>
        )}

        <div className="modal-actions" style={{ marginTop: 16 }}>
          <button className="btn btn-ghost" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" onClick={() => { onSave({ branches }); onClose(); }}>Применить к схеме</button>
        </div>
    </ChainDrawer>
  );
}

function StepConfigModal({ step, onSave, onClose }) {
  if (step.stepType === 'filter') return <FilterConfigModal step={step} onSave={onSave} onClose={onClose} />;

  const [config, setConfig] = useState({ ...(step.config || {}) });
  const u = (k, v) => setConfig({ ...config, [k]: v });
  return (
    <ChainDrawer title={LABELS[step.stepType]} wide={['email','cascade'].includes(step.stepType)} onClose={onClose}>
        {step.stepType==='cascade'&&<WorkflowCascadeEditor value={config} onChange={setConfig}/>}
        {step.stepType === 'wait' && (
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <input aria-label="Длительность ожидания" className="form-input" type="number" min="1" style={{ width: 100 }} value={config.duration || ''} onChange={e => u('duration', parseInt(e.target.value) || '')} />
            <select aria-label="Единица ожидания" className="form-input" style={{ width: 140 }} value={config.unit || 'hours'} onChange={e => u('unit', e.target.value)}>
              <option value="minutes">Минут</option><option value="hours">Часов</option><option value="days">Дней</option><option value="months">Месяцев</option>
            </select>
          </div>
        )}
        {step.stepType === 'sms' && (<>
          <div className="form-group"><label className="form-label">Текст SMS</label>
            <div style={{ fontSize: 10, color: '#9ca3af', marginBottom: 4 }}>Переменные: {'{name}'} {'{balance}'} {'{tier}'}</div>
            <textarea className="form-input" rows={4} value={config.text || ''} onChange={e => u('text', e.target.value)} placeholder="Привет, {name}!" /></div>
          <div className="form-group"><label className="form-label">Цель</label>
            <select className="form-input" value={config.goal_type || ''} onChange={e => u('goal_type', e.target.value)}>
              <option value="">Нет</option><option value="purchase">Покупка</option></select></div>
        </>)}
        {step.stepType === 'email' && (<>
          <EmailEditorInline
            subject={config.subject || ''}
            onSubjectChange={v => u('subject', v)}
            htmlContent={config.html_content || ''}
            onHtmlChange={v => u('html_content', v)}
            designJson={config.design_json || null}
            onDesignChange={v => u('design_json', v)}
          />
          <div className="form-group"><label className="form-label">Цель</label>
            <select className="form-input" value={config.goal_type || ''} onChange={e => u('goal_type', e.target.value)}>
              <option value="">Нет</option><option value="purchase">Покупка</option><option value="email_open">Открытие</option><option value="link_click">Клик</option></select></div>
        </>)}
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" disabled={step.stepType==='cascade'&&!validCascade(config)} onClick={() => { onSave(config); onClose(); }}>Применить к схеме</button>
        </div>
    </ChainDrawer>
  );
}


function stepSummary(s) {
  if (s.type === 'wait') { const u = { minutes: 'мин', hours: 'ч', days: 'дн', months: 'мес' }; return `Пауза ${s.config?.duration || '?'} ${u[s.config?.unit] || ''}`; }
  if (s.type === 'sms') return s.config?.text ? s.config.text.slice(0, 70) + (s.config.text.length > 70 ? '…' : '') : '';
  if (s.type === 'email') return s.config?.subject || '';
  if(s.type==='cascade')return s.config?.email_condition==='unopened'?'Email → SMS при отсутствии открытия':'Резерв только при отказе или недоступности';
  if (s.type === 'filter') {
    const br = s.config?.branches || [];
    return br.length > 0 ? `Веток: ${br.length}` : '';
  }
  return '';
}

export function buildFlow(steps, trigger, runMode, cbs, triggers) {
  const nodes = [], edges = [];
  const tl = (triggers || []).find(t => t.type === trigger)?.label || trigger;
  const rl = runMode === 'once' ? 'Один раз на клиента' : 'При каждом подходящем событии';
  nodes.push({ id: 'start', type: 'start', position: { x: 0, y: 0 }, data: { label: tl, runLabel: rl, onEdit: cbs.onEditStart }, draggable: false });

  const childrenOf = (parentId, branchId) => steps.filter(s => (s.parentId || null) === (parentId === 'start' ? null : parentId) && (s.branch || null) === (branchId || null));
  // Reserve one vertical lane for every leaf, so nested branches never overlap.
  const span = (parentId, branchId) => {
    const children = childrenOf(parentId, branchId);
    if (!children.length) return 1;
    return children.reduce((sum, step) => sum + (step.type === 'filter' && step.config?.branches?.length
      ? step.config.branches.reduce((n, branch) => n + span(step.id, branch.id), 0)
      : span(step.id, null)), 0);
  };
  const mkEdge = (src, tgt, hid, color, label, dashed) => ({
    id: `e-${src}-${tgt}-${hid || 'd'}-${Math.random().toString(36).substr(2,4)}`,
    source: src, target: tgt, sourceHandle: hid || undefined, type: 'smoothstep',
    markerEnd: { type: MarkerType.ArrowClosed, color: color || '#64748b', width: 14, height: 14 },
    style: { stroke: color || '#64748b', strokeWidth: 2, ...(dashed ? { strokeDasharray: '6 4' } : {}) },
    label, labelStyle: { fontSize: 10, fontWeight: 600, fill: color || '#9ca3af' },
    labelBgStyle: { fill: '#1b2335', fillOpacity: 1 }, labelBgPadding: [4, 4], labelBgBorderRadius: 4,
  });

  const process = (parentId, branchId, depth, lane) => {
    const children = childrenOf(parentId, branchId);
    if (children.length === 0) {
      const addId = `add-${parentId}-${branchId || 'd'}`;
      nodes.push({ id: addId, type: 'addStep', position: { x: depth * 370, y: lane * 210 }, data: { parentId, branchId, onAdd: cbs.onAdd } });
      const bc = BRANCH_COLORS[0];
      edges.push(mkEdge(parentId, addId, branchId, '#64748b', null, true));
      return;
    }
    let nextLane = lane;
    children.forEach(step => {
      const stepLane = nextLane;
      const branches = step.type === 'filter' ? (step.config?.branches || []) : [];
      nodes.push({ id: step.id, type: 'step', position: { x: depth * 370, y: stepLane * 210 }, data: {
        nodeId: step.id, stepType: step.type, typeLabel: LABELS[step.type],
        summary: stepSummary(step), config: step.config, branches, needsConfig: step.type==='sms'?!step.config?.text?.trim():step.type==='email'?(!step.config?.subject?.trim()||!step.config?.html_content?.trim()):step.type==='cascade'?!validCascade(step.config):false,
        onEdit: cbs.onEdit, onDelete: cbs.onDelete,
      } });
      const ec = COLORS[step.type] || '#6b7280';
      edges.push(mkEdge(parentId, step.id, branchId, ec));

      if (step.type === 'filter' && branches.length > 0) {
        let branchLane = stepLane;
        branches.forEach(b => {
          process(step.id, b.id, depth + 1, branchLane);
          branchLane += span(step.id, b.id);
        });
        nextLane = branchLane;
      } else {
        process(step.id, null, depth + 1, stepLane);
        nextLane += span(step.id, null);
      }
    });
  };
  process('start', null, 1, 0);
  return { nodes, edges };
}



function ChainEditor({ chain, onClose, onSaved, triggers }) {
  const isEdit = !!chain;
  const [form, setForm] = useState({ name: '', trigger: 'registration', run_mode: 'once', max_runs_per_period: '', period_days: '', pause_hours: '', steps: [], ...(chain || {}) });
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [flowInstance,setFlowInstance] = useState(null);
  useEffect(()=>{if(!flowInstance||!nodes.length)return;const timer=setTimeout(()=>flowInstance.fitView({padding:0.2,maxZoom:1,duration:200}),80);return()=>clearTimeout(timer);},[nodes.length,flowInstance]);
  const [editingStep, setEditingStep] = useState(null);
  const [editingStart, setEditingStart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showTest, setShowTest] = useState(false);
  const [testPhone, setTestPhone] = useState('');
  const [testResult, setTestResult] = useState(null);
  const [testing, setTesting] = useState(false);

  const rebuild = useCallback((f) => {
    const cbs = {
      onAdd: (pid, bid, type) => {
        const id = `s_${Date.now()}`;
        const defs = {
          wait: { duration: 1, unit: 'hours' },
          filter: { branches: [{ id: `b_${Date.now()}`, label: 'Ветка 1', segment_filter: { segments: [], loyalty_tiers: [], place_ids: [] } }] },
          sms: { text: '' },
          email: { subject: '', html_content: '' },
          cascade:{...blankCascade},
        };
        const ns = { id, type, config: defs[type] || {}, parentId: pid === 'start' ? null : pid, branch: bid || undefined };
        setEditingStep({...ns,typeLabel:LABELS[type],stepType:type});
        setForm(prev => { const n = { ...prev, steps: [...prev.steps, ns] }; setTimeout(() => rebuild(n), 0); return n; });
      },
      onEdit: (nid) => { setForm(prev => { const s = prev.steps.find(x => x.id === nid); if (s) setEditingStep({ ...s, typeLabel: LABELS[s.type], stepType: s.type }); return prev; }); },
      onEditStart: () => setEditingStart(true),
      onDelete: (nid) => {
        setForm(prev => {
          const del = new Set();
          const collect = id => { del.add(id); prev.steps.filter(s => s.parentId === id).forEach(s => collect(s.id)); };
          collect(nid);
          const n = { ...prev, steps: prev.steps.filter(s => !del.has(s.id)) };
          setTimeout(() => rebuild(n), 0); return n;
        });
      },
    };
    const { nodes: nn, edges: ee } = buildFlow(f.steps, f.trigger, f.run_mode, cbs, triggers);
    setNodes(nn); setEdges(ee);
  }, []);

  useEffect(() => { rebuild(form); }, []);

  const save = async () => {
    if (!form.name) { toast.error('Введите название'); return; }
    if(form.steps.some(s=>s.type==='cascade'&&!validCascade(s.config))){toast.error('Заполните все тексты каскада');return;}
    setLoading(true);
    try {
      const d = { ...form, max_runs_per_period: form.max_runs_per_period ? parseInt(form.max_runs_per_period) : null, period_days: form.period_days ? parseInt(form.period_days) : null, pause_hours: form.pause_hours ? parseInt(form.pause_hours) : null };
      if (isEdit) { await chainsAPI.update(chain.id, d); toast.success('Сохранено'); } else { await chainsAPI.create(d); toast.success('Создано'); }
      onSaved(); onClose();
    } catch (err) { toast.error(err.response?.data?.detail || 'Ошибка'); }
    finally { setLoading(false); }
  };

  const nt = useMemo(() => nodeTypes, []);

  return (
    <div className="chain-editor">
      <header className="chain-builder-header"><button className="btn btn-ghost btn-sm" onClick={onClose}><ArrowLeft size={16}/> Назад</button><div className="chain-builder-name"><span><GitBranch size={14}/> Конструктор цепочки</span><input aria-label="Название цепочки" placeholder="Название цепочки" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/></div><Link className="btn btn-ghost btn-sm" to="/knowledge?article=chains" target="_blank" rel="noreferrer">Как настроить</Link><button className="btn btn-primary" onClick={save} disabled={loading}>{loading?'Сохраняем…':'Сохранить цепочку'}</button></header>
      <div className="chain-builder-context"><span>Шагов: {form.steps.length}</span><span>{form.run_mode==='once'?'Один раз на клиента':'Повторное участие'}</span><button onClick={()=>setEditingStart(true)}>Настроить вход</button><small>{chain?.is_active?'Активная цепочка · изменения после сохранения':'Изменения применятся после сохранения цепочки'}</small></div>
      <div className="chain-builder-canvas">
        {!form.steps.length&&<div className="chain-builder-empty"><strong>С чего начнём?</strong><span>Настройте вход и добавьте первое действие</span></div>}
        <ReactFlow nodes={nodes} edges={edges} onNodesChange={onNodesChange} onEdgesChange={onEdgesChange}
          onInit={setFlowInstance} nodesFocusable={false} edgesFocusable={false} nodeTypes={nt} fitView fitViewOptions={{ padding: 0.25, maxZoom: 1 }} minZoom={0.2} maxZoom={1.5} nodesConnectable={false} nodesDraggable={false} deleteKeyCode={null}
          proOptions={{ hideAttribution: true }}>
          <Background gap={24} size={1} color="#263147" />
          <Controls position="bottom-left" showInteractive={false} />
        </ReactFlow>
      </div>
      {editingStart && <StartConfigModal form={form} triggers={triggers} onSave={f => { setForm(prev => { const n = { ...prev, ...f }; setTimeout(() => rebuild(n), 0); return n; }); }} onClose={() => setEditingStart(false)} />}
      {editingStep && <StepConfigModal step={editingStep} onSave={cfg => { setForm(p => { const n = { ...p, steps: p.steps.map(s => s.id === editingStep.id ? { ...s, config: cfg } : s) }; setTimeout(() => rebuild(n), 0); return n; }); setEditingStep(null); }} onClose={() => setEditingStep(null)} />}

      {showTest && (
        <div className="modal-overlay" onClick={() => setShowTest(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 500, maxHeight: '80vh', overflowY: 'auto' }}>
            <h2 className="modal-title">🧪 Тестировать цепочку</h2>
            <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 12 }}>
              Все шаги выполнятся мгновенно (ожидания пропускаются). SMS и Email будут реально отправлены.
            </p>
            <div className="form-group">
              <label className="form-label">Телефон клиента</label>
              <input className="form-input" value={testPhone} onChange={e => setTestPhone(e.target.value)}
                placeholder="+79001234567" />
            </div>
            <button className="btn btn-primary" disabled={testing || !testPhone.trim()} style={{ marginBottom: 16 }}
              onClick={async () => {
                setTesting(true); setTestResult(null);
                try {
                  const res = await chainsAPI.test(chain.id, testPhone.trim());
                  setTestResult(res.data);
                } catch (err) { setTestResult({ error: err.response?.data?.detail || 'Ошибка' }); }
                finally { setTesting(false); }
              }}>
              {testing ? 'Выполняется...' : 'Запустить тест'}
            </button>

            {testResult && (
              <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 }}>
                {testResult.error ? (
                  <div style={{ color: '#ef4444', fontWeight: 600 }}>Ошибка: {testResult.error}</div>
                ) : (
                  <>
                    <div style={{ marginBottom: 8 }}>
                      <span style={{ fontWeight: 600 }}>Клиент:</span> {testResult.client?.name || '—'} ({testResult.client?.phone})
                    </div>
                    <div style={{ marginBottom: 8 }}>
                      <span style={{ fontWeight: 600 }}>Шагов выполнено:</span> {testResult.steps_executed}
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      <span style={{ fontWeight: 600 }}>Результат:</span>{' '}
                      <span className={`badge ${testResult.final_status === 'completed' ? 'badge-success' : testResult.final_status === 'filtered_out' ? 'badge-warning' : 'badge-danger'}`}>
                        {testResult.final_status === 'completed' ? 'Завершено' : testResult.final_status === 'filtered_out' ? 'Отфильтрован' : testResult.final_status}
                      </span>
                    </div>
                    <div style={{ fontSize: 12, fontFamily: 'monospace' }}>
                      {testResult.log?.map((l, i) => (
                        <div key={i} style={{ padding: '4px 0', borderBottom: '1px solid #eee', display: 'flex', gap: 8 }}>
                          <span style={{ color: '#9ca3af', width: 20 }}>#{l.step}</span>
                          <span style={{ fontWeight: 600, width: 60 }}>{l.type}</span>
                          <span className={`badge ${l.status === 'running' ? 'badge-info' : l.status === 'completed' ? 'badge-success' : l.status === 'filtered_out' ? 'badge-warning' : 'badge-danger'}`} style={{ fontSize: 10 }}>
                            {l.status}
                          </span>
                          {l.detail && <span style={{ color: '#6b7280' }}>{l.detail}</span>}
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}

            <div className="modal-actions" style={{ marginTop: 12 }}>
              <button className="btn btn-ghost" onClick={() => { setShowTest(false); setTestResult(null); }}>Закрыть</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


export default function ChainsPage() {
  const [chains, setChains] = useState([]);
  const [triggers, setTriggers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditor, setShowEditor] = useState(false);
  const [showAssistant,setShowAssistant]=useState(false);
  const [editChain, setEditChain] = useState(null);
  const [loadError,setLoadError]=useState(false);
  const load = () => { setLoadError(false); chainsAPI.list().then(r => setChains(r.data || [])).catch(() => setLoadError(true)).finally(() => setLoading(false)); };
  useEffect(() => { load(); automationsAPI.triggers().then(r => setTriggers([...(r.data || []), ...((r.data || []).some(t=>t.type==='first_purchase')?[]:[{type:'first_purchase',label:'Первая покупка',group:'Клиент'}])])).catch(() => {}); }, []);
  if (showEditor) return <ChainEditor chain={editChain} triggers={triggers} onClose={() => { setShowEditor(false); setEditChain(null); }} onSaved={load} />;
  if (loading) return <div style={{ padding: 40, color: 'var(--text-muted)' }}>Загрузка...</div>;
  return (
    <div className="animate-in">
      <header className="chains-list-heading"><h1 className="page-title">Цепочки</h1><div className="chains-heading-actions"><button className="btn btn-ghost" onClick={()=>setShowAssistant(true)}><Sparkles size={16}/> AI CRM-маркетолог</button><button className="btn btn-primary" onClick={() => { setEditChain(null); setShowEditor(true); }}><Plus size={16}/> Создать цепочку</button></div></header>
      {showAssistant&&<ChainAssistant onClose={()=>setShowAssistant(false)} onSaved={()=>{setShowAssistant(false);toast.success('Цепочка сохранена выключенной');load();}}/>}
      {loadError&&<p role="alert">Не удалось обновить список. <button className="btn btn-ghost" onClick={load}>Повторить</button></p>}
      <ChainList chains={chains} triggers={triggers} onEdit={c=>{setEditChain(c);setShowEditor(true);}} onReload={load}/>

    </div>
  );
}